import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrophy, faHeart } from "@fortawesome/free-solid-svg-icons";
import "./AuctionEndState.css";
import { getVendasUrl } from "../openVendas";

function brl(price) {
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(price);
}

export function resolveAuctionEndState(auction) {
  if (!auction) return { closed: false, role: null };
  const expired = new Date(auction.end_time).getTime() <= Date.now();
  const closed = auction.status === "ended" || auction.status === "cancelled" || expired;
  if (!closed) return { closed: false, role: null };

  const mine = auction.user_highest_bid != null ? Number(auction.user_highest_bid) : null;
  const winning = Number(auction.current_price || 0);
  const topBid = (auction.bids || [])[0];

  const youWon = mine != null && winning > 0 && Math.abs(mine - winning) < 0.01;
  if (youWon) return { closed: true, role: "winner", amount: winning };
  if (mine != null) return { closed: true, role: "loser", amount: mine, winning };
  return { closed: true, role: "spectator", amount: winning, winnerName: topBid?.user_name || null };
}

export default function AuctionEndState({ auction }) {
  const end = resolveAuctionEndState(auction);
  if (!end.closed) return null;

  if (end.role === "winner") {
    return (
      <div className="adet-end adet-end--win">
        <div className="adet-end-icon" aria-hidden>
          <FontAwesomeIcon icon={faTrophy} />
        </div>
        <p className="adet-end-kicker">Você arrematou</p>
        <h3 className="adet-end-title">A peça é sua</h3>
        <p className="adet-end-lead">
          Seu lance de {brl(end.amount)} foi o maior quando o relógio zerou.
        </p>
        <p className="adet-end-note">
          Peça nova, com caixa, número de série e dustbag. Prazo de 12 horas para confirmar o pagamento.
        </p>
        <a className="adet-end-cta" href={getVendasUrl()} target="_blank" rel="noopener noreferrer">
          Falar com a gente
        </a>
      </div>
    );
  }

  if (end.role === "loser") {
    return (
      <div className="adet-end adet-end--lose">
        <div className="adet-end-icon" aria-hidden>
          <FontAwesomeIcon icon={faHeart} />
        </div>
        <p className="adet-end-kicker">Não foi dessa vez</p>
        <h3 className="adet-end-title">Outra levou — a próxima pode ser sua</h3>
        <p className="adet-end-lead">
          Seu maior lance foi {brl(end.amount)}. A peça fechou em {brl(end.winning)}.
        </p>
        <p className="adet-end-note">
          Fica de olho. Sempre entra peça nova — e o lance abre bem abaixo da loja.
        </p>
        <a className="adet-end-cta adet-end-cta--ghost" href={getVendasUrl()} target="_blank" rel="noopener noreferrer">
          Falar com a gente
        </a>
      </div>
    );
  }

  return (
    <div className="adet-end adet-end--watch">
      <p className="adet-end-kicker">Leilão encerrado</p>
      <h3 className="adet-end-title">
        {end.winnerName ? `${end.winnerName} levou` : "O maior lance levou"}
      </h3>
      <p className="adet-end-lead">Fechou em {brl(end.amount)}.</p>
      <a className="adet-end-link" href={getVendasUrl()} target="_blank" rel="noopener noreferrer">
        t.me/suapersonalshopper
      </a>
    </div>
  );
}
